import React from "react";
import { CarouselProps } from "./Carousel.types";
import { Default } from "./variations/Default";

export const Carousel: React.FC<CarouselProps> = (props) => {
  switch (props.variation) {
    default:
      return <Default {...props} />;
  }
};
